module.exports = __webpack_public_path__ + "static/media/WindRose-thumbnail.141c7d7c.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/ToolCard/thumbnails/WindRose-thumbnail.png
// module id = 1223
// module chunks = 0